import React from 'react';
import { Helmet } from "react-helmet";
import { useLocation } from 'react-router-dom';

const BnaProgramSuccess = () => {
    const location = useLocation();
    const resultData = location.state?.resultData;
    // const resultData = {name: 'S-26 Gold Pro UHT', img: 'https://s-mom-dev.wedv.io/uploads/AW_NST066706_CN_3D_170ml_Group.png'}
    return (
        <div>
            <Helmet>
                <title>S-Mom</title>
                <meta name="title" content="S-Mom" />
                <meta name="description" content="" />
                <meta name="keyword" content="" />
                <meta property="og:title" content="" />
                <meta property="og:description" content="" />
                <meta property="og:image" content="" />
                <meta property="og:url" content="" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="" />
            </Helmet>
            <div id="pageBnaProgramSuccess">
                <main>
                    {/* Logo */}
                    <div className="bna-program-logo">
                        <div className="bna-program-logo-image"></div>
                    </div>
                    {/* Message Section */}
                    <div className="message-section">
                        <div className="message-text">
                            <p>ลงทะเบียน</p>
                            <p>รับสินค้าตัวอย่างสำเร็จ!</p>
                        </div>
                    </div>

                    {/* Product Display Section */}
                    {resultData && (
                        <div className="product-display-section">
                            {/* Product Image */}
                            {resultData.img && (
                                <div className="product-image-container">
                                    <div className="bContent">
                                        <div className='bBackground'> 
                                        <img
                                            src={resultData.img}
                                            alt="S-26 Gold Pro UHT"
                                            className="product-image"
                                        />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Product Text */}
                            {resultData.name && (
                                <div className="product-text-container">
                                    <h3 className="product-name">{resultData.name}</h3>
                                </div>
                            )}
                        </div>
                    )}
                </main>
            </div>
        </div>
    );
};

export default BnaProgramSuccess;
